import ReportGenerative from './reportGenerative'
export default ReportGenerative
